import React, { useState } from 'react';
import { Form, Image, Button } from 'react-bootstrap';
import { signUp } from 'aws-amplify/auth';
import { Link } from 'react-router-dom';

const SignUp: React.FC = () => {
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [checkPassword, setCheckPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    
    const handleSubmit = async () => {
        if(password !== checkPassword) {
            setErrorMessage('パスワードの確認が一致していない')
            return;
        }
        try {
            const { isSignUpComplete, userId, nextStep } = await signUp({
                username,
                password,
                options: {
                    userAttributes: {
                        email
                    },
                },
            })
            if (nextStep.signUpStep === "CONFIRM_SIGN_UP") {
                setErrorMessage('確認メールが送信しました。ご確認してください')
            }
            console.log(isSignUpComplete, userId, nextStep)
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div>
            <section className="registration-nav"></section>
            <section className="section-login login-bg-img">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-6 mx-auto">
                            <div className="login-wrapper bg-white rounded-50 theme-box-shadow-2 p-lg-5 p-4 text-center">
                                <Image className="login-logo mb-5" src="assets/images/login/login-logo.svg" />
                                {errorMessage && (<div>{errorMessage}</div>)}
                                <Form id="loginForm" className="form-theme">
                                    <Form.Group className="form-group">
                                        <Form.Control 
                                            id="email" type="text" 
                                            name="username" className="form-control mb-2" 
                                            placeholder="ユーザーネーム" required 
                                            onChange={(e) => setUsername(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group">
                                        <Form.Control 
                                            id="email" type="text" 
                                            name="email" className="form-control mb-2" 
                                            placeholder="メールアドレス" required 
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group mb-4">
                                        <Form.Control 
                                            id="password" type="password" 
                                            name="password" className="form-control" 
                                            placeholder="パスワード" required 
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group mb-4">
                                        <Form.Control 
                                            id="password" type="password" 
                                            name="checkPassword" className="form-control" 
                                            placeholder="パスワード（確認）" required 
                                            onChange={(e) => setCheckPassword(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Button onClick={handleSubmit} className="btn btn-theme btn-danger rounded-pill px-lg-5 px-4 mb-5">登録
                                    </Button>
                                    <div className=""><Link to="/forgot_password" className="text-link">パスワードを忘れた方はこちら ≫</Link></div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-login-contents text-center">
                <div className="container">
                    <div className="row mx-0">
                        <div className="col-lg-10 px-lg-4 px-0 mx-auto mt-lg-4 mt-2">
                            <Image className="mb-2" src="assets/images/other/icon-light-bg-white-circle-red.svg" />
                            <h3 className="text-md mb-4">Ene Bid とは</h3>
                            <p className="mb-lg-5 mb-sm-4 mb-3 text-sm text-left mr-lg-3">電力供給契約を変更検討中のお客様情報をデータベース化し、
                                電力会社の方へ連携することで自由競争を促す自動応札システムです。</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-login-contents bg-ass-06 text-center">
                <div className="container">
                    <div className="row mx-0">
                        <div className="col-lg-10 px-lg-4 px-0 mx-auto mt-lg-4 mt-2">
                            <Image className="mb-2" src="assets/images/other/icon-trophy-bg-white-circle-red.svg" />
                            <h3 className="text-md mb-5">３つのメリット</h3>
                            <div className="row">
                                <div className="col-md-4 text-center row-eq-height">
                                    <div className="login-item bg-white">
                                        <Image className="mr-4" src="assets/images/login/user-chart.svg" />
                                        <p className="text-sm fw-400">契約を見直したい<br />新規顧客を探せる</p>
                                    </div>
                                </div>
                                <div className="col-md-4 text-center row-eq-height">
                                    <div className="login-item bg-white">
                                        <Image src="assets/images/login/user-office.svg" />
                                        <p className="text-sm fw-400">他社に切り替え検討中の<br />契約者がわかる</p>
                                    </div>
                                </div>
                                <div className="col-md-4 text-center row-eq-height">
                                    <div className="login-item bg-white">
                                        <Image src="assets/images/login/clip-list.svg" />
                                        <p className="text-sm fw-400">応札条件を<br />柔軟に決められる</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default SignUp;